import React, { SVGProps } from "react";

const SvgRoof10 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 350 300"
    {...props}
  >
    <defs>
      <linearGradient
        id="roof10_svg__b"
        x1={236.195}
        y1={210.754}
        x2={225.004}
        y2={191.371}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.471} stopColor="#b4c5d3" stopOpacity={0} />
        <stop offset={1} stopColor="#b4c5d3" stopOpacity={0.35} />
      </linearGradient>
      <linearGradient
        id="roof10_svg__c"
        x1={62.771}
        y1={229.963}
        x2={91.328}
        y2={180.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.316} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="roof10_svg__a"
        x1={328.743}
        y1={157.563}
        x2={328.743}
        y2={131.843}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.117} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof10_svg__d"
        x1={21.708}
        y1={206.274}
        x2={21.708}
        y2={141.382}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.117} stopOpacity={0} />
        <stop offset={0.5} stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof10_svg__e"
        x1={133.233}
        y1={270.565}
        x2={133.233}
        y2={244.845}
        xlinkHref="#roof10_svg__a"
      />
    </defs>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="url(#roof10_svg__b)"
      d="M132.845 244.704v25.72l195.509-113.002v-25.72L132.845 244.704z"
    />
    <path
      fill="url(#roof10_svg__c)"
      d="M132.845 244.482v25.788L21.319 206.031V140.08l111.526 104.402z"
    />
    <path
      fill="#2e99d2"
      d="M340 125.189 133.233 244.845 10 129.484 217.08 10 340 125.189z"
    />
    <g fill="#6d9faf">
      <path d="M69.823 203.343v11.25l-9.353-5.388v-11.25l9.353 5.388zM81.281 209.958v11.25l-9.354-5.388v-11.25l9.354 5.388zM69.823 216.817v11.25l-9.353-5.388v-11.25l9.353 5.388zM81.281 223.432v11.25l-9.354-5.388v-11.25l9.354 5.388z" />
    </g>
    <path fill="url(#roof10_svg__a)" d="M328.243 131.843h1v25.72h-1z" />
    <path fill="url(#roof10_svg__d)" d="M21.208 141.382h1v64.892h-1z" />
    <path fill="url(#roof10_svg__e)" d="M132.733 244.845h1v25.72h-1z" />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M133.233 244.845 10 129.484 217.08 10 340 125.19 133.233 244.845z"
    />
  </svg>
);

export default SvgRoof10;
